import React from "react";
import "./Breadcrumbs.scss";
import ConfigurationHelper from "../../configuration/ClientConfigurationHelper";
import {Box} from "@mui/material";
const breadcrumbsStructureData = (listOfItems) => {
    const schema = document.createElement("script");
    const items = listOfItems.filter(f=>f.url).map((element, index) => {
        return {
            "@type": "ListItem",
            "position": index,
            "name": element.name,
            "item": element.url
        };
    });
    const schemaStructure = {
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": items
    };
    schema.type = "application/ld+json";
    schema.text = JSON.stringify([schemaStructure]);
    document.querySelector("head").appendChild(schema);
};

const Breadcrumbs = props => {
    const list = [
        {
            url: ConfigurationHelper.getClientSiteLinks().home || "/",
            name: "Home"
        },
        {
            url: ConfigurationHelper.getGlobalConfiguration().sub_folder+"/",
            name: "Latest Posts",
            active: props.isHomePage
        },
        ...props.breadcrumbsList
    ];
    const className = props.className ? props.className : "";

    if(props.renderStructureData)
        breadcrumbsStructureData(list);

    return (
        <Box className={className}>
            <ul className={"tvp-breadcrumbs "+(props.keepOnMobile ? "keep-on-mobile": "")}>
                {list.map((item, index) => {

                    return (<li itemScope itemType="http://data-vocabulary.org/Breadcrumb"
                                className={item.hideItemOnMobile ? "hide-item-mobile": ""}
                                key={index}>
                        {item.active ?
                            <span >
                                <span className={(item.active ? "active" : "")} >{item.name}</span>
                            </span> : item.url ?
                                <a itemProp="url" href={item.url}>
                                    <span className={item.highlightMobile ? "highlight" : ""} itemProp="title">{item.name}</span>
                                </a>:
                                <span >
                                <span className={(item.active ? "active" : "")} >{item.name}</span>
                            </span>
                        }
                    </li>)
                })}
            </ul>
        </Box>

    );
};

Breadcrumbs.defaultProps = {
    breadcrumbsList: [],
    isHomePage: false,
    keepOnMobile: false,
    renderStructureData : true
};
export default Breadcrumbs;